export default __webpack_public_path__ + "static/Why Every School Needs A Student Information System-c842e38025cbd3f3dccdc83f81ea8ab0.jpg";